import React,{useEffect, useRef} from 'react';
import HamburgerStyles from './HamburgerButton.module.css';


export default function HamburgerButton({children: navElements}){
    const hamburgerButtonRef=useRef(null);
    const mobileNavModalRef=useRef(null);
    useEffect(()=>{
        const {current:hamburgerButtonDOM}=hamburgerButtonRef;
        const {current:mobileNavDOM}=mobileNavModalRef;
        hamburgerButtonDOM.addEventListener('click',(event)=>{
            hamburgerButtonDOM.classList.toggle(HamburgerStyles['isActive']);
            mobileNavDOM.classList.toggle(HamburgerStyles['Open']);
        })
    },[])
    return <React.Fragment>
                <button ref={hamburgerButtonRef} className={`${HamburgerStyles.Hamburger} ${HamburgerStyles['Hamburger--Emphatic']}`} type="button">
                        <span className={HamburgerStyles['Hamburger-Box']}>
                            <span className={HamburgerStyles['Hamburger-Inner']}></span>
                        </span>
                    </button>
                <div ref={mobileNavModalRef} id={HamburgerStyles['Mobile-Nav__Modal']}>
                    <ul id={HamburgerStyles['Mobile-Nav__Links']}>
                        {
                            React.Children.map(navElements, navElement =>
                                React.cloneElement(navElement, { mobileNavModalRef,hamburgerButtonRef})
                            )
                        }
                    </ul>
                </div>
    </React.Fragment>
}